import { useState, useEffect } from 'react';

const useCategoryManager = (
  handlerFns = [],
  formattedStart,
  formattedEnd,
  selectedTab,
  level
) => {
  const [categoryId, setCategoryId] = useState(null);
  const [categoryName, setCategoryName] = useState(null);
  const buildParams = (customParams = {}) => ({
    formattedStart,
    formattedEnd,
    selectedTab,
    ...customParams,
  });
  const [paramsValue, setParamsValue] = useState(buildParams({
    selectedIds: {
      categoryId: [categoryId],
    }, level: level,
    tab: selectedTab,
  }))

  // Reset category when level or date range changes
  useEffect(() => {
    setCategoryId(null);
    setCategoryName(null);
  }, [level, formattedStart, formattedEnd]);

  // Trigger handler when tab changes and category is selected
  useEffect(() => {
    if (categoryId) {
      callAllHandlers(paramsValue);
    }
  }, [paramsValue]); // Only watch tab



  const callAllHandlers = async (params) => {
    for (const fn of handlerFns) {
      if (typeof fn === 'function') {
        try {
          await fn(params);
        } catch (err) {
          console.error("Handler error:", err);
        }
      }
    }
  };

  const handleCategoryClick = async (asin, id) => {
    setCategoryId(id);
    setCategoryName(asin);
    setParamsValue(buildParams({
      selectedIds: {
        categoryId: [id],
      },
      level: level,
      tab: selectedTab
    }))
  };

  const handleParentProductClick = async (asin, id) => {
    setCategoryId(id);
    setCategoryName(asin);
    
    setParamsValue(buildParams({
      selectedIds: {
        parentProductId: [id],
      },
      level: level,
      tab: selectedTab
    }))
  };


  const onBreadcrumbClick = async (id, label) => {
    let params;
    if (id) {
      setCategoryId(id);
      setCategoryName(label);
      params = buildParams({
        selectedIds: {
          categoryId: [id],
        },
        level: level,
      });
    } else {
      setCategoryId(null);
      setCategoryName(null);
      params = buildParams({
        selectedIds: {
          categoryId: [],
        },
        level: level,
      });
    }
    await callAllHandlers(params);
  };

  return {
    categoryId,
    categoryName,
    handleCategoryClick,
    onBreadcrumbClick,
    setCategoryId,
    setCategoryName,
    handleParentProductClick
  };
};

export default useCategoryManager;
